const BASE_URL = "https://www.whweiying.com";
// const BASE_URL = "https://www.whweiying.com";
const AMapKey = "6e748f9a1f4b580c266a7def59ded5f9";

export default {
  BASE_URL,
  AMapKey,
};
